import { render } from "./Plan.vue?vue&type=template&id=1bc57bda"
import script from "./Plan.vue?vue&type=script&lang=js"
export * from "./Plan.vue?vue&type=script&lang=js"
script.render = render

export default script